/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-betting-icon.get-names.ts 
*/
:host {
  box-sizing: border-box;
  display: inline-block;
  font-size: 0;
  line-height: 1;
}

.ace-betting-icon {
  height: var(--ace-betting-icon-size, 1rem);
  width: var(--ace-betting-icon-size, 1rem);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("data:image/png;base64,CON");
}